
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/account-settings",
      function () {
        return require("private-next-pages/my-account/account-settings.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/account-settings"])
      });
    }
  